<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
        <span class="col-lg-6 m-0 p-0 text-left">
          <button v-bind:class="{ 'font-weight-bold': status == VISIBLE_STATUS }" class="status-button"
            @click="status = VISIBLE_STATUS">{{ $t('visible') }}</button>
          <span v-bind:class="{ 'font-weight-bold': status == VISIBLE_STATUS }">({{ visibleCount }})</span>
          |
          <button v-bind:class="{ 'font-weight-bold': status == NOT_VISIBLE_STATUS }" class="status-button"
            @click="status = NOT_VISIBLE_STATUS">{{ $t('notVisible') }}</button> <span
            v-bind:class="{ 'font-weight-bold': status == NOT_VISIBLE_STATUS }">({{ notVisibleCount }})</span>
        </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="ADD_ACTION">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages"
      :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked"
      @update-requested="updateItemsRequested" :sorter="{ external: true }" :sorterValue="sorterValue"
      @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

const VISIBLE_STATUS = true;
const NOT_VISIBLE_STATUS = false;


export default {
  components: { CTableWrapper, SearchBar },
  data() {
    return {
      status: '',
      searchText: '',
      caption: i18n.t('heros'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'id', label: i18n.t('id'), _classes: 'font-weight-bold', sorter: true },
        { key: 'title', label: i18n.t('title'), sorter: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      VISIBLE_STATUS: VISIBLE_STATUS,
      NOT_VISIBLE_STATUS: NOT_VISIBLE_STATUS,
    }
  },
  computed: {
    ...mapState('heros', ['getHerosOutput']),
    ...mapState('heros', ['deleteHeroByIdOutput']),
    ...mapState('heros', ['putHeroStatusByIdOutput']),
    heroInfo: function () {
      return this.getHerosOutput ? this.getHerosOutput : null;
    },
    visibleCount: function () {
      return this.heroInfo && this.heroInfo.data ? this.heroInfo.data.visible : 0;
    },
    notVisibleCount: function () {
      return this.heroInfo && this.heroInfo.data ? this.heroInfo.data.notVisible : 0;
    },
    items: function () {
      return this.heroInfo && this.heroInfo.data && this.heroInfo.data.heroItems && this.heroInfo.data.heroItems.length ? this.heroInfo.data.heroItems : [];
    },
    pages: function () {
      return this.heroInfo ? this.heroInfo.totalPages : 1;
    }
  },
  mounted: function () {
    this.status = true;
  },
  methods: {
    ...mapActions('heros', ['getHeros']),
    ...mapActions('heros', ['deleteHeroById']),
    ...mapActions('heros', ['putHeroStatusById']),
    rowClicked(item, index) {
      this.$router.push({ name: "HeroEdit", query: { id: item.id }, params: { name: item.title } });
    },
    actionClicked(item, action) {
      switch (action.key) {
        case 'view':
          {
            this.$router.push({ name: "HeroEdit", query: { id: item.id }, params: { name: item.title } });
            break;
          }
        case 'disable':
          {
            if (confirm(this.$i18n.tc('confirmDisable', item.title, { name: item.title }))) {
              this.putHeroStatusById(item.id);
            }
            break;
          }
        case 'enable':
          {
            if (confirm(this.$i18n.tc('confirmEnable', item.title, { name: item.title }))) {
              this.putHeroStatusById(item.id);
            }
            break;
          }
        case 'remove':
          {
            if (confirm(this.$i18n.tc('confirmRemove', item.title, { name: item.title }))) {
              this.deleteHeroById(item.id);
            }
            break;
          }
        default:
          {
            throw "The provided action is not supported!";
          }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage) {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      // List specific parameters
      input.visible = this.status;

      // List specific parameters
      if (this.$route.params.type) {
        input.type = this.$route.params.type;
      }

      this.getHeros(input);
    },
    ADD_ACTION() {
      router.push({ name: 'HeroAdd', params: { type: this.$route.params.type } });
    },
    searchClicked(searchText) {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value) {
      this.sorterValue = value;
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function (val) {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteHeroByIdOutput: function (val) {
      this.loading = true;

      if (val) {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getHerosOutput: function (val) {
      if (val != null) {
        this.loading = false;
      }
    },
    putHeroStatusByIdOutput: function (val) {
      this.loading = true;

      if (val) {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    status: function (val) {
      // Update actions
      switch (val) {

        case VISIBLE_STATUS:
          {
            this.actions = [];
            this.actions.push({ key: 'view', label: this.$i18n.t("view") });
            this.actions.push({ key: 'disable', label: this.$i18n.t("disable") });
            this.actions.push({ key: 'remove', label: this.$i18n.t("remove") });
            break;
          }
        case NOT_VISIBLE_STATUS:
          {
            this.actions = [];
            this.actions.push({ key: 'enable', label: this.$i18n.t("activate") });
            this.actions.push({ key: 'remove', label: this.$i18n.t("remove") });
            break;
          }
        default:
          {
            throw "The provided status is not supported!";
          }
      }
      // Update items
      this.updateItemsRequested(1, this.itemsPerPage);
    },
  }
}
</script>

 
<style>
th {
  border-top: none !important;
}

tr {
  cursor: pointer;
}

.status-button {
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 